import axiosApi from "../../../../components/Api/Axios";
import BackendServices from "../../../../components/Api/BackendService";

export default (id: number) =>
  axiosApi.delete(`${BackendServices.DASHBOARD_SERVICE.DASHBOARD}/${id}`);
